'use client';

import React__default, { forwardRef, useContext, useMemo } from 'react';
import { InputContainerWrapper, SelectedName, EmptyItem, ArrowDownContainer } from './InputContainer.css.js';
import { CascaderContext } from '../../context/reducer.js';
import { ACTIONS } from '../../context/actions.js';
import OverflowItems from './components/OverflowItems/index.js';
import ArrowDownIcon from '../../../Images/ArrowDownIcon/index.js';

var InputContainer = forwardRef(function (_, ref) {
    var _a = useContext(CascaderContext), state = _a.state, props = _a.props, t = _a.t, dispatch = _a.dispatch;
    var isShow = state.isShow, temporaryValue = state.temporaryValue, value = state.value;
    var hasError = props.hasError, styleOptions = props.styleOptions, textOptions = props.textOptions, forResponsive = props.forResponsive, selectLayout = props.selectLayout;
    var handleOnClick = function () {
        if (isShow) {
            dispatch({
                type: ACTIONS.ON_CANCEL
            });
        }
        else {
            dispatch({
                type: ACTIONS.TOGGLE,
                payload: true
            });
        }
    };
    return useMemo(function () {
        return (React__default.createElement(InputContainerWrapper, { isFlex: styleOptions.isFlex, hasError: hasError, hasValue: temporaryValue.length > 0, onClick: handleOnClick, ref: ref, forResponsive: forResponsive, selectLayout: selectLayout === null || selectLayout === void 0 ? void 0 : selectLayout.type, "data-input-container": true },
            React__default.createElement(SelectedName, null, temporaryValue.length === 0 ? (React__default.createElement(EmptyItem, { placeholderColor: styleOptions.placeholderColor, clearSpaceLeft: styleOptions.clearSpaceLeft, forResponsive: forResponsive }, textOptions.placeholder === '' ? t('All job function') : textOptions.placeholder)) : (React__default.createElement(OverflowItems, null))),
            React__default.createElement(ArrowDownContainer, null,
                React__default.createElement(ArrowDownIcon, { width: 20, height: 20 }))));
    }, [isShow, hasError, temporaryValue, value]);
});
var InputContainer$1 = React__default.memo(InputContainer);

export { InputContainer, InputContainer$1 as default };
//# sourceMappingURL=index.js.map
